import { useCallback } from 'react';

import { useConfirmation } from '@admin/components/confirmation';

export const useDispatcherError = () => {
  const { confirm, confirmation } = useConfirmation();

  const showError = useCallback(
    (message: string) => {
      void confirm({
        title: 'Whoops',
        description: message,
        confirm: 'OK',
        showCancel: false,
      });
    },
    [confirm],
  );

  return { showError, confirmation };
};
